import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Offcanvas } from 'react-bootstrap';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import Select from 'react-select';
import _ from 'lodash';

const TenantModal = ({ showModal, handleClose, tenantId, tenantData, addTenant, editTenant, industries, fetchIndustries, tenants, instanceId, instances }) => {
    const [loading, setLoading] = useState(false); // Track loading state

    const [formData, setFormData] = useState({
        instance_id: instanceId || '',
        tenant_info_id: '',
        account_status: '',
        status_note: '',
        login: '',
        ip_check: false,
        ips: '',
        address: '',
        contract_type: '',
        license_type: '',
        subscription_period: '',
        anc_start_date: '',
        setup_start_date: '',
        industry_id: '',
        name: '',
    });

    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (showModal) {
            fetchIndustries();
        }
    }, [showModal]);
    useEffect(() => {
        if (tenantId && tenantData) {
            // If editing an existing tenant, populate the form with the data
            setFormData(tenantData);
        } else if (showModal && !tenantData) {
            // If creating a new tenant, clear the form
            setFormData({
                instance_id: instanceId || '',
                tenant_info_id: '',
                account_status: '',
                status_note: '',
                login: '',
                ip_check: false,
                ips: '',
                address: '',
                contract_type: '',
                license_type: '',
                subscription_period: '',
                anc_start_date: '',
                setup_start_date: '',
                industry_id: '',
                name: '', // Add other fields like `name` if missing
            });
        }
    }, [tenantId, tenantData, showModal, instanceId]);
    
    const sortedInstances = _.sortBy(instances || [], [(inst) => (inst.setup_name || inst.name || "").toLowerCase()]);

    const instanceOptions = sortedInstances.map(inst => ({
        value: inst.id,
        label: inst.setup_name || inst.name
    }));


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        }
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.account_status) newErrors.account_status = 'Account Status is required';
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.tenant_info_id) newErrors.tenant_info_id = 'Tenant ID is required';
        if (!instanceId && !formData.instance_id) newErrors.instance_id = 'Instance selection is required';

        // if (Array.isArray(tenants)) {
        //     const duplicateTenant = tenants.some(
        //         (tenant) => tenant.tenant_id === formData.tenant_id && tenant.instance_id === instanceId && tenant.id !== tenantId
        //     );

        //     if (duplicateTenant) {
        //         newErrors.tenant_id = 'Tenant ID must be unique';
        //     }
        // }

        if (Array.isArray(tenants)) {
            const duplicateTenant = tenants.some((tenant) => {
                const isDuplicate = String(tenant.tenant_info_id) === String(formData.tenant_info_id) &&
                    String(tenant.instance_id) === String(formData.instance_id || instanceId) &&
                    tenant.id !== tenantId;

                return isDuplicate;
            });

            if (duplicateTenant) {
                console.log("Duplicate Tenant Found!");
                newErrors.tenant_info_id = 'Tenant ID must be unique within the instance';
            } else {
                console.log("No Duplicate Found.");
            }
        }

        console.log("Validation Errors:", newErrors);

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Start the button-specific loader
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }

        try {
            let apiErrors;
            if (tenantId) {
                // Edit tenant
                apiErrors = await editTenant(tenantId, formData);
            } else {
                // Add new tenant
                apiErrors = await addTenant(formData);
            }
            if (apiErrors && Object.keys(apiErrors).length > 0) {
                setErrors(apiErrors); // Display validation errors
            } else {
                setErrors({}); // Clear errors on success
                handleClose(); // Close modal on success
            }
        } catch (error) {
            console.error("An error occurred:", error); // Log any unexpected errors
            setErrors({ apiError: "An unexpected error occurred. Please try again." });
        } finally {
            setLoading(false); // Stop the button-specific loader
        }
    };

    return (

     <>
      
        <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '680px' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{tenantId ? 'Edit Tenant' : 'Create Tenant'}</Offcanvas.Title>
            </Offcanvas.Header>
            <hr style={{ margin: 0 }} /><br/>

            <Offcanvas.Body>
                {errors.general && (
                    <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '13px' }}>
                        {errors.general}
                    </div>
                )}
                {errors.apiError && (
                    <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '13px' }}>
                        {errors.apiError}
                    </div>
                )}
                <Form >
                    {/* Only show instance selection when an instance context is NOT provided (e.g. in AllTenantList) */}
                    {!instanceId && (
                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group controlId="instance_id" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Instance</Form.Label>
                                    <Select
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                fontSize: '13px',
                                                borderRadius: '14px',
                                                height: '39px',
                                                minHeight: '39px',
                                                border: '0.5px solid rgb(232, 233, 237)',
                                                maxWidth: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: '13px',
                                                zIndex: 3
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: '39px',
                                                padding: '0 12px'
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                margin: '0px'
                                            }),
                                            indicatorSeparator: (base) => ({
                                                ...base,
                                                display: 'none'
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: '39px'
                                            })
                                        }}
                                        name="instance_id"
                                        placeholder="Select Instance"
                                        options={instanceOptions}
                                        value={instanceOptions.find(opt => String(opt.value) === String(formData.instance_id))}
                                        onChange={(selectedOption) => {
                                            setFormData(prev => ({
                                                ...prev,
                                                instance_id: selectedOption ? selectedOption.value : ''
                                            }));
                                            if (errors.instance_id) {
                                                setErrors(prev => ({ ...prev, instance_id: undefined }));
                                            }
                                        }}
                                        className={errors?.instance_id ? 'is-invalid' : ''}
                                        isSearchable={true}
                                        isClearable={true}
                                    />
                                    {errors.instance_id && <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>*{errors.instance_id}</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="name" className='mb-3 '>
                                <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className={`form-control ${errors?.name ? 'is-invalid' : ''}`}


                                />
                                {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}


                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="tenant_info_id" className='mb-3'>
                                <Form.Label style={{ fontSize: "13px" }}>Tenant ID</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="tenant_info_id"
                                    value={formData.tenant_info_id}
                                    onChange={handleChange}
                                    className={`form-control ${errors.tenant_info_id ? 'is-invalid' : ''}`}

                                />
                                {errors.tenant_info_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.tenant_info_id}</div>}

                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="contract_type" className='mb-3'>
                                <Form.Label style={{ fontSize: "13px" }}>Contract Type</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="contract_type"
                                    value={formData.contract_type}
                                    onChange={handleChange}
                                >
                                    <option value="">Select</option>
                                    <option value="basic">Basic</option>
                                    <option value="standard">Standard</option>
                                    <option value="premium">Premium</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="account_status" className='mb-3'>
                                <Form.Label style={{ fontSize: "13px" }}>Account Status</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="account_status"
                                    value={formData.account_status}
                                    onChange={handleChange}
                                    className={`form-control ${errors?.account_status ? 'is-invalid' : ''}`}

                                >
                                    <option value="">Select</option>

                                    <option value="active">Active</option>
                                    <option value="suspended">Suspended</option>
                                    <option value="deactivated">Deactivated</option>
                                </Form.Select>
                                {errors.account_status && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.account_status}</div>}

                            </Form.Group>

                        </Col></Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="status_note" className='mb-3'>
                                <Form.Label style={{ fontSize: "13px" }}>Status Note</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    as="textarea"
                                    rows={3}
                                    name="status_note"
                                    value={formData.status_note}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="address">
                                <Form.Label style={{ fontSize: "13px" }}>Address</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    as="textarea"
                                    rows={3}
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>



                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="ips">
                                <Form.Label style={{ fontSize: "13px" }}>IPs</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="ips"
                                    value={formData.ips}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="login">
                                <Form.Label style={{ fontSize: "13px" }}>Login</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="login"
                                    value={formData.login}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="industry_id" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Industry</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="industry_id"
                                    value={formData.industry_id}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Industry</option>
                                    {industries.map(industry => (
                                        <option key={industry.id} value={industry.id}>
                                            {industry.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="setup_start_date">
                                <Form.Label style={{ fontSize: "13px" }}>Setup Start Date</Form.Label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        className="w-100"
                                        sx={{ width: '100%', maxWidth: '290px' }}
                                        format="DD/MM/YYYY"
                                        value={formData.setup_start_date ? dayjs(formData.setup_start_date) : null}
                                        onChange={(newValue) => {
                                            handleChange({ target: { name: 'setup_start_date', value: newValue ? newValue.format('YYYY-MM-DD') : '' } });
                                        }}
                                        renderInput={(params) => (
                                            <TextField 
                                                {...params} 
                                                fullWidth
                                                sx={{ 
                                                    maxWidth: '290px',
                                                    '& .MuiOutlinedInput-root': { 
                                                        borderRadius: '14px', 
                                                        height: '39px', 
                                                        backgroundColor: '#fff'
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '0.5px solid rgb(232, 233, 237)'
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '10px 14px',
                                                        fontSize: '13px'
                                                    }
                                                }} 
                                            />
                                        )}
                                        slotProps={{
                                            textField: {
                                                sx: { 
                                                    maxWidth: '290px',
                                                    '& .MuiOutlinedInput-root': { 
                                                        borderRadius: '14px', 
                                                        height: '39px', 
                                                        backgroundColor: '#fff'
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '0.5px solid rgb(232, 233, 237)'
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '10px 14px',
                                                        fontSize: '13px'
                                                    }
                                                }
                                            },
                                            actionBar: {
                                                actions: ['today', 'clear'],
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        {/* <Col md={6}>
                            <Form.Group controlId="license_type">
                                <Form.Label style={{ fontSize: "13px" }}>Contact Type</Form.Label>
                                <Form.Select
                                    style={{ fontSize: "13px" }}
                                    name="contact_type"
                                    value={formData.contact_type}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Type</option>
                                    <option value="technical">Technical</option>
                                    <option value="account manager">Account Manager</option>
                                    <option value="support">Support</option>

                                </Form.Select>
                            </Form.Group>
                        </Col> */}
                        <br />
                        <Col md={6}>
                            <Form.Group controlId="ip_check">
                                <div style={{ display: 'flex', alignItems: 'center', height: '38px', paddingTop: '50px' }}>
                                    <Form.Check
                                        type="checkbox"
                                        name="ip_check"
                                        label="Enable IP Check"
                                        checked={formData.ip_check}
                                        onChange={handleChange}
                                        style={{ fontSize: '13px', width: '100%' }}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="license_type">
                                <Form.Label style={{ fontSize: "13px" }}>License Type</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="license_type"
                                    value={formData.license_type}
                                    onChange={handleChange}
                                >
                                    <option value="">Select</option>
                                    <option value="subscription">Subscription</option>
                                    <option value="perpetual">Perpetual</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>



                    <Row className="mb-3">



                        {formData.license_type === 'subscription' && (
                            <Col md={6}>
                                <Form.Group controlId="subscription_period">
                                    <Form.Label style={{ fontSize: "13px" }}>Subscription Period</Form.Label>
                                    <Form.Select
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        name="subscription_period"
                                        value={formData.subscription_period}
                                        onChange={handleChange}
                                    >
                                        <option value="monthly">Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="halfyearly">Half-Yearly</option>
                                        <option value="yearly">Yearly</option>
                                        <option value="subscription free">Subscription Free</option>


                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        )}


                        <Col md={6}>

                            {formData.license_type === 'perpetual' && (
                                <Form.Group controlId="anc_start_date">
                                    <Form.Label style={{ fontSize: "13px" }}>AMC Start Date</Form.Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className="w-100"
                                            sx={{ width: '100%', maxWidth: '280px' }}
                                            format="DD/MM/YYYY"
                                            value={formData.anc_start_date ? dayjs(formData.anc_start_date) : null}
                                            onChange={(newValue) => {
                                                handleChange({ target: { name: 'anc_start_date', value: newValue ? newValue.format('YYYY-MM-DD') : '' } });
                                            }}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    fullWidth
                                                    sx={{ 
                                                        maxWidth: '280px',
                                                        '& .MuiOutlinedInput-root': { 
                                                            borderRadius: '14px', 
                                                            height: '39px', 
                                                            backgroundColor: '#fff'
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: '0.5px solid rgb(232, 233, 237)'
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            padding: '10px 14px',
                                                            fontSize: '13px'
                                                        }
                                                    }} 
                                                />
                                            )}
                                            slotProps={{
                                                textField: {
                                                    sx: { 
                                                    maxWidth: '280px',
                                                    '& .MuiOutlinedInput-root': { 
                                                        borderRadius: '14px', 
                                                        height: '39px', 
                                                        backgroundColor: '#fff'
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '0.5px solid rgb(232, 233, 237)'
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '10px 14px',
                                                        fontSize: '13px'
                                                    }
                                                }
                                            },
                                            actionBar: {
                                                actions: ['today', 'clear'],
                                            }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Form.Group>
                            )}
                        </Col></Row>


                </Form>
            </Offcanvas.Body>
            <div className="offcanvas-footer d-flex justify-content-end p-3 border-top">
                <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                    Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                    Save
                </button>
            </div>
        </Offcanvas>
        </>

    );
};

export default TenantModal;

